import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Globálna klávesová skratka pre rýchly prístup do admin panela.
 * Ctrl/Cmd + Shift + A => /admin ak je prihlásený, inak /login
 */
export default function AdminShortcut() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const handler = (e) => {
      const isMod = e.ctrlKey || e.metaKey;
      if (isMod && e.shiftKey && (e.key === "A" || e.key === "a")) {
        e.preventDefault();
        navigate(user && user.id ? "/admin" : "/login");
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [navigate, user]);

  return null;
}
